import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Notice, { MessageType } from './notice'
import './index.css'

export interface MessageApi {
    info: (text: string, duration?: number) => void
    success: (text: string, duration?: number) => void
    warning: (text: string, duration?: number) => void
    error: (text: string, duration?: number) => void
}

export interface Notice {
    text: string
    key: string
    type: MessageType
    duration?: number
}

let seed = 0
const now = Date.now()
const getUuid = () => {
    const id = seed
    seed += 1
    return `MESSAGE_${now}_${id}`
}

let add: (notice: Notice) => void

export const MessageContainer = () => {
    const [notices, setNotices] = useState<Notice[]>([])
    const timeout = 3000
    const maxCount = 10
    const remove = (notice: Notice) => {
        const { key } = notice
        setNotices((prev) => prev.filter(({ key: itemKey }) => key !== itemKey))
    }
    add = (notice: Notice) => {
        setNotices((prev) => [...prev, notice])
        setTimeout(() => {
            remove(notice)
        }, notice.duration || timeout)
    }

    useEffect(() => {
        if (notices.length > maxCount) {
            const [firstNotice] = notices
            remove(firstNotice)
        }
    }, [notices])
    return (
        <div className='message-container'>
            <TransitionGroup>
                {notices.map((notice) => (
                    <CSSTransition
                        key={notice.key}
                        classNames='toast-notice-wrapper notice'
                        timeout={300}
                    >
                        <Notice {...notice} />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        </div>
    )
}

let el = document.querySelector('#message-wrapper')
if (!el) {
    el = document.createElement('div')
    el.id = 'message-wrapper'
    document.body.appendChild(el)
}
ReactDOM.render(<MessageContainer />, el)

const api: MessageApi = {
    info: (text, duration) => {
        add({ text, duration, key: getUuid(), type: 'info' })
    },
    success: (text, duration) => {
        add({ text, duration, key: getUuid(), type: 'success' })
    },
    warning: (text, duration) => {
        add({ text, duration, key: getUuid(), type: 'warning' })
    },
    error: (text, duration) => {
        add({ text, duration, key: getUuid(), type: 'error' })
    },
}

export default api
